import { useEffect } from "react";
import ShieldCheck from "react-bootstrap-icons/dist/icons/shield-check";

export default function ReviewsDisplay() {
  useEffect(() => {
    const existing = document.querySelector(
      'script[src*="doctify-widget-autoresize-plugin.js"]'
    );
    if (existing) return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://www.doctify.com/wv2/doctify-widget-autoresize-plugin.js?tenantId=athena-uk&widgetName=average-carousel-rating-widget&containerId=0d6mncpj";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section id="reviews" className="py-1 py-md-5 bg-brand-orange text-white">
      <div className="main-wrap">
        <div className="row g-1 g-md-4 align-items-start">
          <div className="col-lg-4">
            <h2 className="fw-semibold mb-1 mb-md-2">Reviews</h2>
            <div className="text-white-50">
              A few words from clients about their experience
            </div>

            <div className="mt-2 mt-md-4 d-flex gap-2 gap-md-3 align-items-start">
              <div className="reviewIconCircle border d-flex align-items-center justify-content-center flex-shrink-0">
                <ShieldCheck size={20} className="text-brand-orange" />
              </div>
              <div className="text-white-75">Verified patient reviews</div>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="p-2 p-md-4 rounded-4 bg-white bg-opacity-10 border border-white border-opacity-10">
              <iframe
                id="0d6mncpj"
                className="doctify-widget w-100"
                src="https://www.doctify.com/wv2/average-carousel-rating-widget?containerId=0d6mncpj&language=en&profileType=specialist&slugs=dr-benjamin-piper&tenantId=athena-uk&theme=darkNavy&widgetName=average-carousel-rating-widget"
                width="100%"
                frameBorder="0"
                scrolling="no"
                name="average-carousel-rating-widget"
                title="Doctify reviews"
              >
                Browser doesn't support frames
              </iframe>

              <div className="mt-1 mt-md-3 text-white-50 small">
                Use arrows to browse
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
